export const systemTagMixin = {    
    data: () => ({
        nativeData: [],
    }),
    computed: {
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"]('superadmin');
        },
    },
    methods: {
        isSystem(row) {
            return this.nativeData.find(element => element.id == row.id && element.tags.length && element.tags[0].pivot.archived_at == null);
        },
    }
};



// WEBPACK FOOTER //
// ./src/mixins/systemTagMixin.js